import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('carSaleMstStore', Object.keys(getters)),
	...mapState('carSaleMstStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('carSaleMstStore', Object.keys(actions)),
	...mapMutations('carSaleMstStore', Object.keys(mutations))
};
